
  import {
    defineComponent,
    onMounted,
    onBeforeUnmount,
    ref,
    defineAsyncComponent,
  } from 'vue';
  import { useAbility } from '@casl/vue';
  import RegisteredAccountsWidget from '@/components/widgets/charts/RegisteredAccountsWidget.vue';
  import BrokersAccountsWidget from '@/components/widgets/charts/BrokersAccountsWidget.vue';
  import MarketeersAccountsWidget from '@/components/widgets/charts/MarketeersAccountsWidget.vue';
  import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  const AuctionsSummaryWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/AuctionsSummaryWidget.vue')
  );
  const TradesSummaryWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/TradesSummaryWidget.vue')
  );
  const SubscriptionsWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/SubscriptionsWidget.vue')
  );
  const BrokersAdsPackagesWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/BrokersAdsPackagesWidget.vue')
  );
  const MapPackgesWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/MapPackgesWidget.vue')
  );
  const AdsSummeryWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/AdsSummeryWidget.vue')
  );
  const IveStatsWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/IveStatsWidget.vue')
  );
  const IreStatsWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/IreStatsWidget.vue')
  );
  const OthersSummaryWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/OthersSummaryWidget.vue')
  );
  const AdsTypesSummaryWidget = defineAsyncComponent(
    () => import('@/components/widgets/charts/AdsTypesSummaryWidget.vue')
  );

  export default defineComponent({
    name: 'dashboard',
    components: {
      SubscriptionsWidget,
      BrokersAdsPackagesWidget,
      MapPackgesWidget,
      RegisteredAccountsWidget,
      BrokersAccountsWidget,
      MarketeersAccountsWidget,
      AdsSummeryWidget,
      OthersSummaryWidget,
      IveStatsWidget,
      IreStatsWidget,
      TradesSummaryWidget,
      AuctionsSummaryWidget,
      AdsTypesSummaryWidget,
    },
    setup() {
      const { can } = useAbility();
      const store = useStore();

      const showGroup2 = ref(false);
      const showGroup3 = ref(false);
      const showGroup4 = ref(false);
      const showGroup5 = ref(false);
      const showGroup6 = ref(false);

      const timerIds: ReturnType<typeof setTimeout>[] = [];

      onMounted(() => {
        setCurrentPageTitle('Dashboard');
        reinitializeComponents();

        const steps: [() => void, number][] = [
          [
            () => {
              showGroup2.value = true;
            },
            300,
          ],
          [
            () => {
              showGroup3.value = true;
            },
            600,
          ],
          [
            () => {
              showGroup4.value = true;
            },
            900,
          ],
          [
            () => {
              showGroup5.value = true;
            },
            1200,
          ],
          [
            () => {
              showGroup6.value = true;
            },
            1500,
          ],
          [
            () => {
              store.dispatch(
                Actions.REMOVE_BODY_CLASSNAME,
                'page-loading-over'
              );
            },
            1500,
          ],
        ];

        steps.forEach(([fn, delay]) => {
          timerIds.push(setTimeout(fn, delay));
        });
      });

      onBeforeUnmount(() => {
        timerIds.forEach(clearTimeout);
      });
      return {
        can,
        showGroup2,
        showGroup3,
        showGroup4,
        showGroup5,
        showGroup6,
      };
    },
  });
